<template>
  <s-detail
    :formList="formList"
    :rules="rules"
    :api="api"
    :beforeSave="beforeSave"
    :afterGet="afterGet"
    ref="formRef"
  >
  </s-detail>
</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const formRef = ref();
    const state = reactive({
      formList: [
        {
          title: "基本信息",
          form: [
            // { label: "设备图片", value: "logoFile",component:'sUpload'},
            { label: "设备名称", value: "name" },
            {
              label: "ABC类",
              value: "abcId",
              component: "s-select",
              placeholder: "请选择",
              url: "getSystemDictType",
              params: {
                id: "device_abc_type",
              },
              field: {
                dictValue: "value",
                dictLabel: "label",
              },
            },
            { label: "设备型号", value: "model" },
            {
              label: "设备类型",
              value: "categoryId",
              component: "s-select",
              placeholder: "请选择",
              url: "getCategoryTreeApi",
              field: {
                id: "value",
                name: "label",
              },
            },
            {
              label: "资产状态",
              value: "assetStatusId",
              component: "s-select",
              placeholder: "请选择",
              url: "getSystemDictType",
              params: {
                id: "device_asset_status",
              },
              field: {
                dictValue: "value",
                dictLabel: "label",
              },
            },
            { label: "规格", value: "spec" },
            {
              value: "deptId",
              placeholder: "请选择",
              component: "sTreeSelect",
              label: "所属组织",
              url: "treeSelectByUserApi",
              field: {
                id: "value",
                label: "label",
              },
            },
            { label: "责任人", value: "dutyUserId" },
            { label: "品牌", value: "brand" },
            {
              label: "区域位置",
              placeholder: "请选择",
              value: "areaId",
              component: "s-select",
              url: "getSelectListByDeptId",
              getParams: (form) => {
                return {
                  id: form?.deptId ?? "",
                };
              },
              field: {
                id: "value",
                label: "label",
              },
            },
            {
              label: "设备编码",
              value: "code",
              placeholder: "系统自动生成",
              disabled: true,
            },
            {
              label: "设备流水号",
              value: "number",
              placeholder: "系统自动生成",
              disabled: true,
            },
          ],
        },
        {
          title: "设备信息",
          form: [
            {
              label: "安装日期",
              value: "installDate",
              component: "el-date-picker",
            },
            { label: "安装位置", value: "address", maxlength: "100" },
            { label: "故障次数", value: "faultCountText", maxlength: "100" },
            { label: "运行时间", value: "runningTimeText", maxlength: "100" },
            { label: "故障状态", value: "faultStatus", maxlength: "100" },
            { label: "运行状态", value: "runningStatus", maxlength: "100" },
          ],
        },
        {
          title: "厂家信息",
          form: [
            { label: "供应商名称", value: "supplier", maxlength: "20" },
            { label: "出厂编号", value: "produceCode", maxlength: "100" },
            {
              label: "出厂日期",
              value: "produceDate",
              component: "el-date-picker",
            },
            { label: "保修年限", value: "warranteePeriod", maxlength: "2" },
            { label: "生产厂家", value: "producer", maxlength: "100" },
          ],
        },
      ],
      rules: {
        name: [
          { required: true, message: "设备名称不能为空", trigger: "blur" },
        ],
        categoryId: [
          { required: true, message: "设备类型不能为空", trigger: "blur" },
        ],
        abcId: [{ required: true, message: "ABC类不能为空", trigger: "blur" }],
        assetStatusId: [
          { required: true, message: "资产状态不能为空", trigger: "blur" },
        ],
        areaId: [
          { required: true, message: "区域位置不能为空", trigger: "blur" },
        ],
        deptId: [
          { required: true, message: "所属组织不能为空", trigger: "blur" },
        ],
      },
      api: {
        detail: "lookInfoDeviceApi",
        add: "addDeviceApi",
        edit: "editDeviceApi",
      },
    });
    onMounted(() => {
      console.log(formRef.value, "==============");
    });
    const beforeSave = (form) => {
      return {
        name: form.name,
        model: form.model,
        categoryId: form.categoryId,
        assetStatusId: form.assetStatusId,
        spec: form.spec,
        dutyUserId: form.dutyUserId,
        brand: form.brand,
        areaId: form.areaId,
        installDate: form.installDate,
        address: form.address,
        supplier: form.supplier,
        produceCode: form.produceCode,
        produceDate: form.produceDate,
        warranteePeriod: form.warranteePeriod,
        producer: form.producer,
        abcId: form.abcId,
        deptId: form.deptId,
        code: form.id
          ? form.code
          : form.deptId + "-" + form.areaId + "-" + form.categoryId + "-",
        id: form.id,
        logoFile: form.logoFile,
      };
    };
    const afterGet = (form) => {
      return {
        ...form,
        logoFile: [
          {
            name: "food.jpeg",
            url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
          },
        ],
      };
    };
    return {
      ...toRefs(state),
      beforeSave,
      afterGet,
      formRef,
    };
  },
});
</script>

<style lang="less" scoped>
.workbench-container {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  position: relative;
  .workbench-set {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    border-radius: 0 0 50% 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .workbench-draggable {
    width: 100%;
    .workbench-empty {
      width: 100%;
      height: 800px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .draggable-list {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      justify-content: space-between;
    }
  }
}
.item {
  text-align: left;
  margin-bottom: 16px;
  height: 450px;
  background-color: white;
  border-radius: 8px 8px 8px 8px;
  position: relative;
  // overflow: hidden;
  &.flex1 {
    width: calc((100% - 32px) / 3);
  }
  &.flex2 {
    width: calc(((100% - 32px) / 3) * 2 + 16px);
  }
  &.flex3 {
    width: 100%;
  }
  &:hover {
    .item-size {
      display: flex;
    }
  }
  .item-size {
    position: absolute;
    top: -1px;
    right: 20px;
    width: 50%;
    height: 55px;
    background-color: white;
    display: none;
    align-items: center;
    justify-content: flex-end;
    z-index: 99;
    > div {
      width: 20px;
      margin-right: 5px;
      cursor: pointer;
      text-align: center;
      border-radius: 2px;
    }
  }
  //   .item-name {
  //     height: 55px;
  //     border-bottom: 1px solid #F5F5F5;
  //   }
  //   .item-content {
  //     height: calc(100% - 56px);
  //   }
}

.ghost {
  border: solid 1px rgb(19, 41, 239);
}
.chosenClass {
  background-color: #f1f1f1;
}
</style>
